<template>
  <form class="portal-form" @submit.prevent="submit">
    <p v-if="fromMatching" class="rb-ob-q-hint">{{ $t('intake.matchUi.supportIntro') }}</p>
    <p v-if="fromIntakeHelp" class="rb-ob-q-hint">{{ $t('intake.disp.accountSupportNote') }}</p>
    <p v-if="fromRefund" class="rb-ob-q-hint">{{ $t('intake.portal.refundSupportIntro') }}</p>
    <p v-if="sessionAccess" class="rb-ob-q-hint">{{ lang === 'fa' ? 'درخواست هنوز ارسال نشده است. مشکل ورود را بنویس و سپس درخواست را ثبت کن.' : 'Your request has not been sent. Describe the access problem, then submit it.' }}</p>
    <p v-if="sessionAccess" class="rb-ob-status" role="note">{{ sessionReference }}</p>
    <p v-if="needsLogin" class="rb-ob-status" role="status">{{ $t('intake.portal.needsLogin') }} <router-link class="btn btn-ghost" :to="loginLink">{{ $t('intake.portal.needsLoginCta') }}</router-link></p>
    <label class="field">
      <span>{{ $t('intake.portal.requestTopic') }}</span>
      <select v-model="topic"><option v-for="opt in topics" :key="opt" :value="opt">{{ topicText(opt) }}</option></select>
    </label>
    <label class="field"><span>{{ $t('intake.portal.requestBody') }}</span><textarea v-model="body" :placeholder="$t('intake.portal.requestPlaceholder')"></textarea></label>
    <p class="rb-ob-status" role="note">{{ $t('intake.portal.supportMessengerNote') }}</p>
    <div class="actions">
      <button class="btn btn-primary" type="submit" :disabled="submitting || needsLogin">{{ submitting ? $t('intake.portal.loading') : $t('intake.portal.requestSubmit') }}</button>
      <router-link class="btn btn-secondary" :to="cancelLink">{{ $t('intake.portal.requestCancel') }}</router-link>
    </div>
    <p class="rb-ob-status" role="status" aria-live="polite">{{ formStatus }}</p>
  </form>
</template>

<script>
import {createSupportRequest, hasAuthToken} from '@/intake/portalApi'
import {loginRedirectQuery} from '@/router/loginReturn'
import {sessionAccessSupportContext} from '@/intake/sessionPreparation'

export default {
  name: 'PortalRequestNewStep',
  data() {
    const topics = ['BOOKING','PAYMENT','ACCESS','DELIVERY','DISSATISFACTION']
    const q = String(this.$route.query.topic || 'BOOKING').toUpperCase()
    const fromIntakeHelp = this.$route.query.from === 'intake-help'
    const fromRefund = this.$route.query.from === 'refund'
    const sessionAccess = sessionAccessSupportContext(this.$route.query)
    const factorId = /^\d{1,20}$/.test(String(this.$route.query.factor_id || '')) ? String(this.$route.query.factor_id) : ''
    const kind = String(this.$route.query.kind || '')
    const intakeKind = ['more', 'unsupported', 'private', 'specialist', 'ops', 'crisis'].includes(kind) ? kind : 'ops'
    let body = ''
    if (this.$route.query.from === 'match-declined') body = this.$t('intake.matchUi.supportBody', {reference: String(this.$route.query.recommendation || '').replace(/[^a-zA-Z0-9-]/g, '').slice(0, 64)})
    if (fromIntakeHelp) body = this.$t('intake.disp.accountSupportBody')
    if (fromRefund) body = this.$t('intake.portal.refundSupportBody') + (factorId ? '\n' + this.$t('intake.portal.refundSupportReference', {reference: factorId}) : '')
    return {
      topic: sessionAccess ? 'ACCESS' : fromRefund ? 'PAYMENT' : fromIntakeHelp ? 'ACCESS' : topics.includes(q) ? q : 'BOOKING',
      body,
      sessionAccess,
      fromMatching: this.$route.query.from === 'match-declined',
      fromIntakeHelp,
      fromRefund,
      factorId,
      intakeKind,
      topics,
      submitting: false,
      needsLogin: false,
      formStatus: '',
      idempotencyKey: `support-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`,
    }
  },
  computed: {
    lang() { return this.$route.params.lang || 'fa' },
    sessionReference() {
      return this.sessionAccess ? (this.lang === 'fa' ? 'شمارهٔ جلسه: ' : 'Session reference: ') + this.sessionAccess.id : ''
    },
    loginLink() {
      return {name: 'login', params: {lang: this.lang}, query: loginRedirectQuery(this.$route, 'portalRequestNew')}
    },
    cancelLink() {
      if (this.sessionAccess) return {
        name: this.sessionAccess.returnTo === 'room' ? 'intakeSessionRoom' : 'intakeSessionWait',
        params: {lang: this.lang}, query: {id: this.sessionAccess.id},
      }
      if (this.fromIntakeHelp) return this.intakeKind === 'crisis'
        ? {name: 'intakeCrisis', params: {lang: this.lang}}
        : {name: 'intakeDisp', params: {lang: this.lang, kind: this.intakeKind}}
      if (this.fromRefund) return {name: 'portalRefund', params: {lang: this.lang}, query: this.factorId ? {id: this.factorId} : {}}
      return {name: this.fromMatching ? 'intakeMatches' : 'portalSupport', params: {lang: this.lang}}
    },
  },
  mounted() { this.needsLogin = !hasAuthToken() },
  methods: {
    topicText(topic) {
      const key = 'intake.portal.requestTopic_' + String(topic).toLowerCase()
      const value = this.$t(key)
      return value === key ? topic : value
    },
    submit() {
      if (this.submitting || this.needsLogin) return
      if (!String(this.body || '').trim()) {
        this.formStatus = this.$t('intake.portal.requestBodyRequired')
        return
      }
      this.submitting = true
      this.formStatus = ''
      const details = this.sessionAccess ? String(this.body).trim() + '\n' + this.sessionReference : this.body
      return createSupportRequest(this.sessionAccess ? 'ACCESS' : this.topic, details, this.idempotencyKey)
          .then((request) => {
            if (!request || !request.id) throw new Error('SUPPORT_REQUEST_RECEIPT_MISSING')
            this.$router.push({name:'portalRequestDetail',params:{lang:this.lang},query:{id:String(request.id)}})
          })
          .catch(() => { this.formStatus = this.$t('intake.portal.requestSendFail') })
          .finally(() => { this.submitting = false })
    },
  },
}
</script>
